"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarAndLineComposedChartContainer = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BarAndLineComposedChartContainer = exports.BarAndLineComposedChartContainer = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e15fv7zs0"
} : {
  target: "e15fv7zs0",
  label: "BarAndLineComposedChartContainer"
})("width:", props => props.width && props.width, ";height:", props => props.height && props.height, ";");